import React from 'react';
import { Box, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { PAGE_HEADER_MARGIN_BOTTOM } from '@/constants/spacing';

type PageHeaderProps = {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  sx?: SxProps<Theme>;
};

export function PageHeader({ icon, title, description, action, sx }: PageHeaderProps) {
  return (
    <Box sx={{ marginBottom: PAGE_HEADER_MARGIN_BOTTOM, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1.5, flexWrap: 'wrap', ...sx }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1, minWidth: 0 }}>
        {icon && (
          <Box
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '48px',
              height: '48px',
              borderRadius: 1,
              backgroundColor: `${theme.palette.primary.main}1A`, // ~10% alpha
              flexShrink: 0,
            })}
          >
            <Box
              component="span"
              sx={(theme) => ({
                display: 'inline-flex',
                color: theme.palette.primary.main,
                '& svg': { width: 24, height: 24 },
              })}
            >
              {icon}
            </Box>
          </Box>
        )}
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h4" sx={(theme) => ({ fontSize: '20px', fontWeight: 700, color: theme.palette.text.primary, margin: 0 })}> {/* Reduced from 24px for 150% zoom compensation */}
            {title}
          </Typography>
          {description && (
            <Typography variant="body2" sx={(theme) => ({ fontSize: '12px', color: theme.palette.text.secondary, margin: 0 })}> {/* Reduced from 14px for 150% zoom compensation */}
              {description}
            </Typography>
          )}
        </Box>
      </Box>
      {action && (
        <Box sx={{ flexShrink: 0 }}>
          {action}
        </Box>
      )}
    </Box>
  );
}


